/**
 * @generated SignedSource<<85d6ee10ccc882fe19f04ceff57a316e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment$data = {
  readonly issueByKey: {
    readonly childIssues: {
      readonly __typename: "JiraChildIssuesWithinLimit";
      readonly issues: {
        readonly " $fragmentSpreads": FragmentRefs<"progressSummary_issueViewChildIssuesPanel">;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment";
};
export type view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment$key = {
  readonly " $data"?: view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "issueKey"
    }
  ],
  "kind": "Fragment",
  "name": "view_issueViewCommonViews_ChildIssuesPanelBaseWithFragment",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "key",
          "variableName": "issueKey"
        }
      ],
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "issueByKey",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "childIssues",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "activeIssuesOnly",
                      "value": true
                    },
                    {
                      "kind": "Literal",
                      "name": "activeProjectsOnly",
                      "value": true
                    }
                  ],
                  "concreteType": "JiraIssueConnection",
                  "kind": "LinkedField",
                  "name": "issues",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "progressSummary_issueViewChildIssuesPanel"
                    }
                  ],
                  "storageKey": "issues(activeIssuesOnly:true,activeProjectsOnly:true)"
                }
              ],
              "type": "JiraChildIssuesWithinLimit"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "a2ad230914026793a63baafd396b249e";

export default node;
